import React from 'react';
import styled from 'styled-components';

const NotLoggedInOverlay = styled.div`
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default () => (
  <NotLoggedInOverlay>Logging you in via Single Sign-On...</NotLoggedInOverlay>
);
